module.exports = __webpack_public_path__ + "img/model_3.c7101dc9.png";